export const getFormattedCurrency = (
  value: number | undefined,
  config?: Intl.NumberFormatOptions,
) => {
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...config,
  };
  return new Intl.NumberFormat('en-GB', options).format(value ?? 0);
};
